import CopyIcon from '@svg/duplicate-cards.svg';
import React, { useState } from 'react';
import { Button } from '../../Button/Button';
import { useHandleCopySql } from './buttonHandlers/useHandleCopySql';

export function CopySqlButton({
  datasetOriginLabel,
  datasetId,
  organizationId,
  className,
}: {
  datasetOriginLabel: string;
  datasetId: string;
  organizationId: string;
  className?: string;
}) {
  const [isFetchingSql, setIsFetchingSql] = useState(false);
  const handleCopySql = useHandleCopySql(datasetOriginLabel, setIsFetchingSql);

  return (
    <Button
      variant="text"
      color="primary"
      onClick={() => handleCopySql(datasetId, organizationId)}
      disabled={isFetchingSql}
      className={className}
    >
      <CopyIcon />
      {isFetchingSql ? 'Generating SQL...' : 'Copy SQL'}
    </Button>
  );
}
